import { Component, computed, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { PathwayFacade } from '@app/store/pathway';

@Component({
    selector: 'app-predefined-pathway-delete-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.css'],
    imports: [TranslateModule, ButtonModule, Tooltip],
})
export class DeleteButtonComponent {
    private readonly pathwayFacade = inject(PathwayFacade);
    private readonly confirmationService = inject(ConfirmationService);
    private readonly translateService = inject(TranslateService);

    readonly pathwayId = input.required<string>();
    readonly schoolIds = input.required<string[]>();
    readonly organisationIds = input.required<string[]>();
    readonly saving = input<boolean>(false);
    readonly testId = input.required<string>();

    readonly hasAssignments = computed(() => this.schoolIds().length > 0 || this.organisationIds().length > 0);

    onDelete(): void {
        this.confirmationService.confirm({
            header: this.translateService.instant('predefinedPathways.delete.header'),
            message: this.translateService.instant('predefinedPathways.delete.message'),
            icon: 'pi pi-exclamation-triangle',
            rejectButtonProps: {
                label: this.translateService.instant('predefinedPathways.delete.reject'),
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: this.translateService.instant('predefinedPathways.delete.accept'),
                severity: 'danger',
            },
            accept: () => {
                this.pathwayFacade.deletePathway(this.pathwayId());
            },
        });
    }
}
